export const profileMessages = {
  en: {
    ABSENCE_CREATED: "Absence was successfully created",
    THE_TASK_WAS_SUBMITTED_SUCCESSFULLY: "The task was submitted successfully",
    ABSENCE_UPDATED: "Absence was successfully updated",
    ABSENCE_CLOSED: "Absence was successfully closed",
    CONTACT_INFO_UPDATED: "Contact Info Updated Successfully",
    PASSWORD_UPDATED: "Password Updated Successfully",
    MY_PASSWORD_UPDATED: "Password Updated Successfully",
    DYNAMIC_QUESTIONS_SUBMITTED: "Dynamic questions submitted successfully",
    STANDARD_QUESTIONS_SUBMITTED: "Standard questions submitted successfully",
    REFERRAL_QUESTION_SUBMITTED: "Referral submitted successfully",
  },
};

export default {
  en: {
    REPORT_NEW_ABSENCE: "Report New Absence",
    TYPE_AND_DURATION: "Type and Duration",
    ID: "ID",
    START_DATE: "Start Date",
    START_RTW_DATES: "Start-RTW Dates",
    RETURN_TO_WORK: "Return to Work",
    REASON_FOR_THE_ABSENCE: "Reason for the Absence",
    EMPLOYEE_REF_NO: "Employee Ref No",
    EMPLOYEE_CAN_BE_CONTACTED_ON: "Employee can be contacted on",
    SPELL_COUNT: "{count} spell",
    SPELL_COUNT_plural: "{count} spells",
    COUNT_WORKING_DAY_LOST: "{count} working day lost",
    COUNT_WORKING_DAY_LOST_plural: "{count} working days lost",
    COUNT_WORKING_HOUR_LOST: "{count} working hour lost",
    COUNT_WORKING_HOUR_LOST_plural: "{count} working hours lost",
    ALERTS_TRIGGERED_DURING_THIS_ABSENCE: "Alerts triggered during this Absence",
    CLOSED: "Closed",
    START_DATE_AND_TIME: "Start Date & Time",
    POSITION_ID: "Position ID",
    POSITION_REF: "Position Ref",
    WEEKLY_CONTRACTED_HOURS: "Weekly Contracted Hours",
    DAYS_PER_YEAR: "Days Per Year",
    EFFECTIVE_FROM_DATE: "Effective From Date",
    EFFECTIVE_END_DATE: "Effective End Date",
    SALARY: "Salary",
    WORKING_DAYS_YEAR: "Working Days / Year",
    DATE_ASSIGNED: "Date assigned",
    ROLE_NAME: "Role Name",
    ASSIGNED_BY: "Assigned By",
    TOTAL_FTE: "Total FTE",
    FTE: "FTE",
    ABSENCES: "Absences",
    ADD_INTERACTION: "Add Interaction",
    ADVISOR: "Advisor",
    INTERACTION_NOTES: "Interaction Notes",
    NOTIFICATIONS: "Notifications",
    NOTIFICATION_ID: "Notification ID",
    METHOD: "Method",
    RECEIPENTS: "Receipents",
    DATE_SENT: "Date Sent",
    CONSENT_TO_SHARE: "Consent to Share",
    DATE_CAPTURED: "Date Captured",
    ABSENCE_ID: "Absence ID",
    FIT_DATE: "Fit Date",
    RTW_DATE: "RTW Date",
    RTW_DATE_AND_TIME: "RTW Date & Time",
    ABSENCE_REASON_CLASSIFICATION: "Absence Reason Classification",
    CONSENT_STATUS: "Consent Status",
    CONSENT_GIVEN: "Consent Given",
    DATE_REPORTED: "Date Reported",
    DATE_CLOSED: "Date Closed",
    EMPLOYEE_NAME: "Employee Name",
    EMPLOYEMENT_INFO: "Employment Info",
    EMPLOYMENT_START: "Employment Start",
    SERVICE_LENGTH: "Service Length",
    CONTRACTED_HOURS: "Contracted Hours",
    ANNUAL_WORKING_DAYS_AVAILABLE: "Annual Working Days Available",
    PERSONAL_EMAIL_ADDRESS: "Personal Email Address",
    WORK_EMAIL: "Work Email",
    HOME_PHONE: "Home Phone",
    HOME_PHONE_NUMBER: "Home Phone Number",
    MOBILE_PHONE: "Mobile Phone",
    MOBILE_PHONE_NUMBER: "Mobile Phone Number",
    WORK_PHONE: "Work Phone",
    DATE_REGISTERED: "Date Registered",
    PAGE_NUMBER: "Showing",
    PAGE_OF: "of",
    LINKS_AND_ATTACHMENTS: "Links & Attachments",
    MY_ABSENCE_STATISTICS: "My Absence Statistics",
    MY_ABSENCE_STAGE: "My Absence Stage",
    CURRENT_MONITORING_STAGE: "Current Monitoring Stage",
    MONITORING_HISTORY: "Monitoring History",
    MY_EMPLOYEES: "My Employees",
    EMPLOYEE_AUDIT: "Employee Audit",
    MY_PERSONAL_DETAILS: "My Personal Details",
    YEARS: "years",
    ACCESS: "Access",
    CLOSE_ABSENCE: "Close Absence",
    CLOSE_ABSENCE_QUESTION: "Are you sure you want to close this absence?",
    CONFIRM_CLOSE_ABSENCE: "Yes, Close Absence",
    CONFIRM_RE_OPEN_ABSENCE: "Yes, Re-Open Absence",
    RE_OPEN_ABSENCE_QUESTION: "Are you sure you want to re-open this absence?",
    RE_OPEN: "Re-Open",
    ADDITIONAL_INFORMATION: "Additional Information",
    CANCEL_ABSENCE: "Cancel Absence",
    CANCEL_ABSENCE_QUESTION:
      "Are you sure you want to cancel this absence? \n" +
      "\n" +
      "If it is cancelled, a confirmation email will be sent to your employer to keep them up to date.\n",
    CONFIRM_CANCEL_ABSENCE: "Yes, Cancel Absence",
    STANDARD_QUESTIONS: "Standard Questions",
    STANDARD_QUESTIONS_TOOLTIP:
      "Standard questions form part of an absence interaction. They are asked of the employee by our advisor at specific junctions within the overall call flow, and are intended to facilitate the capture of vital additional information relevant to the absence itself. By nature, standard questions are not customisable (in the sense that the purpose and functioning of the question cannot be made bespoke), however, certain aspects of a standard question are easily updated by selecting the 'Edit' button. Draft changes can be saved and, when ready, submitted for approval by a GoodShape representative.  Note, it is not possible to implement a change if a pending change request is already in process.",
    DYNAMIC_QUESTIONS: "Dynamic Questions",

    // Absence Statistics
    ABSENCE: "Absence",
    ABSENCE_MEASURE: "Absence Measure",
    ORGANISATION_AVERAGE: "Organisation Average",
    NUMBER_OF_ABSENCES: "Numbers of Absences",
    NUMBER_OF_DAYS: "Numbers of Days",
    NUMBER_OF_SPECIFIC_AREA: "Numbers in Specified Areas",
    ALERTS_TRIGGERED: "Alerts Triggered",
    REFERRALS_MADE: "Referrals Made",
    RTWS_TO_BE_COMPLETED: "RTWs To Be Completed",
    ABSENCES_RATE_PERC: "Absence Rate %",
    ABSENCE_RATES: "Absence Rates",
    BRADFORD_SCORE: "Bradford Score",
    TOTAL_DAYS_LOST_BY_WEEKDAY: "Total Days Lost (By Weekday)",
    DAYS_LOST_BY_ST_AND_LT_ABSENCE: "Days Lost By ST and LT Absence",
    SHORT_TERM: "Short Term",
    LONG_TERM: "Long Term",
    DAYS_LOST_PER_REASON: "Days Lost Per Reason",
    REASON: "Reason",
    DAYS: "Days",
    AREA_WITH_ACCESS: "Areas I have Access To",
    // Absence Stage
    ALERT_ID: "Alert ID",
    ALERT_TRIGGERED: "Alert Triggered",
    LEVEL: "Level",
    EFFECTIVE_FROM: "Effective From",
    LATEST_EVENT: "Latest Event",
    LAST_UPDATED_BY: "Last Updated By",
    LAST_MEETING_DATE: "Last Meeting Date",
    NEXT_REVIEW_DATE: "Next Review Date",
    EVENT_DATE: "Event Date",
    ACTIVITY_TYPE: "Activity Type",
    ACTIONED_BY: "Actioned By",
    DETAILS: "Details",
    EFFECTIVE_DATE: "Effective Date",
    FURTHER_SUPPORT_ACTIONS: "Further Support Actions",
    MEETING_DATE: "Meeting Date",
    STATUS: "Status",
    ADD_CONTACT: "Add Contact",
    POSITION: "Position",
    LAST_NAME: "Last Name",
    NOTIFICATION_TYPE: "Notification Type",
    ADDITIONAL_CONTACTS: "Additional Contacts",
    COMPLIANCE: "Compliance",
    TASK_COMPLIANCE: "Task Compliance",
    ADDITIONAL_CONTACTS_FOR: "Additional Contacts for {name}",
    MY_CONTACTS: "My Contacts",
    MY_REQUESTED_NEW_NOTIFICATION_CONTACT: "My Requested: New Notification Contacts",
    MY_REQUESTED_NOTIFICATION_TYPE_CHANGES: "My Requested: Notification Type Changes",
    MY_REQUESTED_REMOVED_NOTIFICATION_CONTACT: "My Requested: Removed Notification Contacts",
    MY_EMPLOYEE_TITLE_TOOLTIP_DESCRIPTION:
      "Listed below are the employees for which you are a FULL notification contact, meaning that you are eligible to access their record. You can also click on the View button to see who else receives notifications for the employee.",
    MY_ABSENCES_ADDITIONAL_QUESTION:
      "Is there any additional information you would like me to pass to your employer?",
    DEVELOPER: "Developer",
    NURSE_ADVISOR: "Nurse Advisor",
    LEAD_NURSE_ADVISOR: "Lead Nurse Advisor",
    ADVANCED_ABSENCE_ADVISOR: "Advanced Absence Advisor",
    CONTACT_CENTRE_MANAGER: "Contact Centre Manager",
    TEXT_TO_CLOSE_SERVICE: "Text To Close Service",
    THIRD_PARTY_APPLICATION: "Third Party Application",
  },
};
